import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Praesentations-/Demo-Modus-Store.
 *
 * Wenn `anonymize` aktiv ist, werden in der UI sensible Daten (Kunden-/
 * Lieferantennamen, Betraege, IBANs, Belegnummern, E-Mails etc.) deterministisch
 * durch Platzhalter ersetzt – rein clientseitig. Backend-Daten bleiben unveraendert.
 *
 * Primaerer Use-Case: Der User zeigt die Anwendung live oder per Screenshot,
 * ohne echte Debitoren-/Kreditoren-/Kontoauszugs-Daten preiszugeben.
 */
interface PresentationState {
  anonymize: boolean
  toggleAnonymize: () => void
  setAnonymize: (v: boolean) => void
}

export const usePresentationStore = create<PresentationState>()(
  persist(
    (set, get) => ({
      anonymize: false,
      toggleAnonymize: () => set({ anonymize: !get().anonymize }),
      setAnonymize: (v: boolean) => set({ anonymize: v }),
    }),
    {
      name: 'presentation-storage',
      partialize: (state) => ({ anonymize: state.anonymize }),
    },
  ),
)
